<!-- * no changes here * -->
<div class="flex flexAlign-center">
  <mat-form-field class="col__ border-0 bg-color--none mb-0"
                  [ngClass]="{'col__xs--55': withTypeSelect}">
    <mat-label>Search Fields…</mat-label>
    <input matInput
           tabindex="0"
           aria-label="Search Fields"
           cdkFocusInitial
           autocomplete="off"
           [formControl]="filterTextControl"
           type="search">
  </mat-form-field>

  <div class="col__ col__xs--45 color--gray--008 right select-info__controls"
       *ngIf="withTypeSelect">

    <ng-container *ngIf="targetType === 'EntityType'">
      <button mat-button
              class="mr-0050 ml-0050 pl-0025 pr-0025"
              [matMenuTriggerFor]="etMenu">
        {{selectedEntityType?.namePlural ? (selectedEntityType?.namePlural | propercase) : 'All Entity Types'}}
      </button>
      <mat-menu #etMenu="matMenu"
                class="ab-menu-panel">
        <button mat-menu-item
                role="menuitemradio"
                [ngClass]="{active: selectedEntityType == null}"
                (click)="entityTypeSelected(null)">All Entity Types</button>
        <button *ngFor="let et of entityTypeOptions"
                mat-menu-item
                role="menuitemradio"
                [ngClass]="{active: selectedEntityType && selectedEntityType.id == et.id}"
                (click)="entityTypeSelected(et)">
          {{ et.namePlural | propercase }}</button>
      </mat-menu>
    </ng-container>

    <ng-container *ngIf="targetType === 'EntityConnectionType'">
      <button mat-button
              class="mt-0050 mr-0050 ml-0050 pl-0025 pr-0025"
              [matMenuTriggerFor]="ectMenu">
        <app-connection-type-name *ngIf="selectedEntityConnectionType"
                                  [connectionType]="selectedEntityConnectionType">
        </app-connection-type-name>
        <span *ngIf="!selectedEntityConnectionType">
          All Connection Types
        </span>
      </button>
      <mat-menu #ectMenu="matMenu"
                class="ab-menu-panel">
        <button mat-menu-item
                role="menuitemradio"
                [ngClass]="{active: selectedEntityConnectionType == null}"
                (click)="entityConnectionTypeSelected(null)">All Connection Types</button>
        <button *ngFor="let ect of entityConnectionTypeOptions"
                mat-menu-item
                role="menuitemradio"
                [ngClass]="{active: selectedEntityConnectionType && selectedEntityConnectionType.id == ect.id}"
                (click)="entityConnectionTypeSelected(ect)">
          <app-connection-type-name [connectionType]="ect">
          </app-connection-type-name>
        </button>
      </mat-menu>
    </ng-container>

  </div>
</div>
<div class="select-all-tags-wrap p-0100 pt-0062 pb-0062 bg-color--gray--000 border-1 border-x-0 border-bottom-0"
     *ngIf="!loading && multiple && visibleCategoryCount > 0 &&!hideSelectAll">
  <button class="link link--noline p-0 min-height-0 tile__heading mb-0 color--blue"
          (click)="selectAllClicked()">
    <i class="fas fa-check-square txt-14 mr-0025"></i>
    Select All {{visibleCategoryCount}} Results
  </button>
</div>
<mat-selection-list dense
                    (selectionChange)="onItemSelected($event)"
                    [multiple]="multiple"
                    class="ab-list-group ab-list-group--scrollable ab-list-group--core-fields forced-scrollbar">
  <app-spinner *ngIf="loading"></app-spinner>

  <ng-container *ngFor="let group of groups; let i = index">
    <mat-subheader class="caps p-0100 pt-0075 pb-0025 txt-fw-600 d-block color--gray truncate">
      <ng-container >
        <i class="fal fa-solar-system color--purple mr-0012"
           [matTooltip]="'This section is universal, as are the fields within it. Responses to universal fields are shared across the organization.'"
           *ngIf="group.isUniversal"></i>
      </ng-container>
      {{group.name}}
    </mat-subheader>
    <mat-list-option *ngFor="let category of group.categories"
                     [selected]="isSelected(category?.id)"
                     [togglePosition]="'before'"
                     [value]="category"
                     class="txt-16">
      <mat-icon class="d-flex flexAlign-center flexJustify-center pos-relative br-0"
                *ngIf="category.readonly"
                [matTooltip]="'This field is “Read Only”'"
                matListIcon>
        <i class="fal fa-stack-1x color--gray h-auto lh-normal"
           [ngClass]="getFieldTypeClass(category)"
           style="font-size:.8em;transform: translateY(-1px);"></i>
        <i class="fal fa-ban fa-stack-1x color--gray--003"
           style="font-size:1.25em;text-shadow: 0 2px 0 white, 2px 0 0 white;"></i>
      </mat-icon>
      <mat-icon fontSet="fal"
                *ngIf="!category.readonly"
                [fontIcon]="getFieldTypeClass(category)"
                matListIcon></mat-icon>
      <span matLine
            class="truncate">
        <ng-container >
          <i class="fal fa-solar-system color--purple mr-0025"
             [matTooltip]="'This field is universal; its responses are shared across all campaigns in this organization.'"
             *ngIf="group.isUniversal"></i>
        </ng-container>
        {{category.name}}
      </span>
    </mat-list-option>
  </ng-container>
</mat-selection-list>
